import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { mergeMap, catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
    constructor(@Inject('userService') private userService: UserService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.userService.getTokenSilently$().pipe(
            mergeMap((token) => {
                const tokenReq = req.clone({
                    setHeaders: { Authorization: `Bearer ${token}` },
                });
                return next.handle(tokenReq);
            }),
            catchError((err) => throwError(err))
        );
    }
}
